import type { Config } from "mixpanel-browser";
import mixpanel from "mixpanel-browser";
import { IS_PRODUCTION, MIXPANEL_TOKEN } from "./env";

export const MIX_PANEL_PERSISTENCE_NAME = "mixpanel";
const PERSISTENCE = "localStorage";
const TRACK_PAGEVIEW = "full-url";

const mixPanelConfig: Partial<Config> = {
  persistence: PERSISTENCE,
  debug: !IS_PRODUCTION,
  track_pageview: TRACK_PAGEVIEW,
  persistence_name: MIX_PANEL_PERSISTENCE_NAME,
};

mixpanel.init(MIXPANEL_TOKEN, mixPanelConfig);

export default mixpanel;
